<template>
	<div class="page_content explore_entity_inside program" aria-label="my program status">
		<div class="row page-heading">
  		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
    		<span class="module_icon icon-list"></span>
    		<label v-if="programGuide && programGuide.title" id="programGuideTitle" class="head_txt module_type_name">
      		Program: {{programGuide.title}}
    		</label>
  		</div>

  		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container">
    		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
          <span class="btn_ic ic-back"></span>
          <span class="btn_txt">{{deCamelCase()}}</span>
        </b-btn>        
  		</div>
    </div>


		<div class="page_content_container">
  		<div v-if="programGuide && programGuide.title">
  			<program-guide-menu
    			:cipCode="programGuide.cipCode"
    			:programGuideCode="programGuide.code"
    			:type="programGuide.type"
    			:returnTo="returnTo"
    			:active="'spotlightAlumni'">
  			</program-guide-menu>
  		</div>

  		<div class="row pg_content list_view">
  			<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
					<div class="row pg_sec career_prospect_v2">
      			<div class="col-6 hd ace_sec_hd">
        			<h2>Spotlight Alumni</h2>        			
        		</div>
            <div class="col-12 sec_content">
              <template v-if="spotlightPersons.length > 0">
                <div class="row result_row" v-for="(person, index) in spotlightPersons">
                  <div class="col-12">
                    <div class="row entity_detail_section">
                      <div class="col-12 title_row">
                        <span class="title ace_sec_txt" :id="'title_' + index" :aria-label="person.title">{{person.title}}{{getClassOf(person)}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
                    <div class="thumbnail_container ace_sec">
                      <div class="thumbnail_img" v-if="person.thumbnailURI">
                        <img v-bind:src="person.thumbnailURI">
                      </div>
                      <div class="thumbnail" v-else>
                        <div class="person_thumbnail">
                          <div class="thumbnail_container">                                  
                            <div class="default">
                              <div class="thumbnail">
                                <div class="ic thumbnail_icon icon-mentor" style="color: #787878;"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section">
                    <div class="row">
                      <div class="col-12 description ace_sec_txt" :id="'biography_' + index" v-if="person.biography">
                        <span class="desc_txt" v-html="person.biography"></span>
                      </div>
                      <div class="col-12 no_description empty_pattern ace_sec_txt" v-else>
                        Biography not added
                      </div>
                      <template v-if="person.biography && person.biography.length > 226">
                        <div class="col-12">
                          <span class="float-right" style="cursor: pointer; color: #0645AD;" @click="expandCollapseBio(index)" :id="'more-less-' + index">{{getMoreLessLabel(index)}}</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

                <div class="row pg_sec sec_career">
                  <div class="col-12 hd ace_sec" aria-label="Career Options" style="margin-bottom: 0px;" v-if="topCareers.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11" style="margin-left: -25px;">
                        <div style="float: left; width: 230px;">
                          <h2 aria-label="Top Alumni Careers">Top Alumni Careers</h2>
                        </div>                        
                      </div>
                      <div class="col-12 ace_sec" aria-label="Careers Chart">
                        <div class="bar_chart_container bar_label_inside">
                          <div class="accordion acrdn_top_careers" role="tablist">
                            <template v-for="(career, index) in topCareers">
                              <div class="row bar_row ace_sec">
                                <div class="col-12">
                                  <b-card no-body>
                                    <b-card-header header-tag="header" class="row_hd" role="tab">
                                      <b-button block v-b-toggle="'acrdnTopCareer_' + index" variant="info">
                                        <span class="title">
                                          <span v-if="career.careerThumbnail">
                                            <img v-bind:src="career.careerThumbnail" style="height: 40px; width: 40px;">
                                          </span>
                                          <span class="ml-3" @click.stop="navigateToCareer(career)" style="cursor: pointer;">{{career.careerTitle}}</span>
                                        </span>
                                        <span class="ic ic8-circle-up"></span>
                                        <span class="ic ic8-circle-down"></span>
                                      </b-button>
                                    </b-card-header>
                                    <b-collapse :visible="index === 0" :id="'acrdnTopCareer_' + index" accordion="careers-accordion" role="tabpanel">
                                      <b-card-body>
                                        <div class="row content_sec jobs_outlook">
                                          <div class="card col-4 salary">
                                            <div class="card-body">
                                              <div class="crd_data">
                                                <div class="crd_data_inner">
                                                  <div class="ic_container">
                                                    <div class="ic ic8-salary"></div>
                                                  </div>
                                                  <div class="values">
                                                    <div class="main_val_1" v-if="career.medianIncome">
                                                      <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(career.medianIncome)"></div>
                                                    </div>
                                                    <div class="add_val" v-if="career.maxIncome">
                                                      hi - $<span v-html="addCommaInNumber(career.maxIncome)"></span>
                                                    </div>
                                                    <div class="add_val" v-else>
                                                      hi - <span class="info_no_val">N/A</span>
                                                    </div>
                                                    <div class="add_val" v-if="career.minIncome">
                                                      low - $<span v-html="addCommaInNumber(career.minIncome)"></span>
                                                    </div>
                                                    <div class="add_val" v-else>
                                                      low - <span class="info_no_val">N/A</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="crd_title">
                                                <span class="title_txt">
                                                  <span class="ic">
                                                    <span class="ic8-salary"></span>
                                                  </span>
                                                  <span class="txt">
                                                    <span class="txt_1">Median </span>
                                                    <span class="txt_2">Income</span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="card col-4">
                                            <div class="card-body">
                                              <template>
                                                <div class="crd_data" :aria-label="'Estimated Job Growth ' + career.timeframe + ' ' + career.growth + '%'">
                                                  <div class="row">
                                                    <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
                                                      <div class="row legend">
                                                        <div class="col-6 lg_lft">0%</div>
                                                        <div class="col-6 lg_rgt">15%</div>
                                                      </div>
                                                      <div class="gph_chart gph_pie_chart">
                                                        <doughnut-chart :chart-data="growthPieData"  :id="'gauge-' + index" :options="growthPieOptions" @afterComplete="callDrawNeedle('gauge-' + index, career.growth)"></doughnut-chart>
                                                      </div>
                                                    </div>
                                                    <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val">
                                                      <span class="val_1_txt" v-html="(Math.round((career.growth) * 100) / 100).toFixed(1)"></span><span>%</span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="crd_title">
                                                  <span class="title_txt">
                                                    <span class="txt_1">Estimated Job Growth </span>
                                                    <span class="txt_2">{{career.timeframe}}</span>
                                                 </span>
                                                </div>
                                              </template>
                                            </div>
                                          </div>

                                          <div class="card col-4 postings">
                                            <div class="card-body">
                                              <div class="crd_data">
                                                <div class="crd_data_inner">
                                                  <div class="ic_container">
                                                    <div class="ic ic8-job2"></div>
                                                  </div>
                                                  <div class="values">
                                                    <div class="main_val_1">
                                                      <span class="val_1_txt" v-html="formatNumericVal(career.openings)"></span>
                                                    </div>
                                                  </div>
                                               </div>
                                              </div>
                                              <div class="crd_title">
                                                <span class="title_txt">
                                                  <span class="ic">
                                                    <span class="ic8-job2"></span>
                                                  </span>
                                                  <span class="txt">
                                                    <span class="txt_1">Job Postings </span>
                                                    <span class="txt_2">2023 - 2033</span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="employers mb-4" v-if="career.employers && career.employers.length>0">
                                          <div class="bar_content">
                                            <div class="row">
                                              <div class="col-12" style="padding: 15px 25px;">
                                                <span>Companies that are hiring Alumni</span>
                                              </div>
                                              <div class="col-12 ml-4">
                                                <div class="row bar_container mb-2" v-for="employer in career.employers" style="margin-left: -10px !important; margin-right: 32px !important;">
                                                  <div class="mt-2 ml-4 w-100">
                                                    <span class="float-left">{{employer.companyTitle}}</span>
                                                    <span class="float-right mr-4">{{employer.totalCount}} hired</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 hd ace_sec" style="margin-bottom: 0px;" v-if="topCompanies.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11 mb-2" style="margin-left: -25px;">
                        <div style="float: left; width: 300px;">
                          <h2 aria-label="Companies Hiring Alumni">Companies Hiring Alumni</h2>
                        </div>                        
                      </div>
                      <div class="col-12 ace_sec bar_chart_container">
                        <div class="companies bar_row" style="margin-left: 10px !important; margin-right: 32px !important;">
                          <div class="bar_content">
                            <div class="row">
                              <div class="col-12" :class="{'text-center': (topCompanies.length === 0)}">
                                <template v-if="topCompanies.length > 0">
                                  <div class="row bar_container mb-2" v-for="item in topCompanies">
                                    <div class="mt-2 ml-4 w-100">
                                      <span class="float-left">{{item.companyTitle}}</span>
                                      <span class="float-right mr-4">{{item.totalCount}} hired</span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span>Data not available</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 hd ace_sec" style="margin-bottom: 0px;" v-if="topIndustries.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11 mb-2" style="margin-left: -25px;">
                        <div style="float: left; width: 325px;">
                          <h2 aria-label="Popular Alumni Industries">Popular Alumni Industries</h2>
                        </div>                        
                      </div>
                      <div class="col-12 ace_sec bar_chart_container">
                        <div class="industries bar_row" style="margin-left: 10px !important; margin-right: 32px !important;">
                          <div class="bar_content">
                            <div class="row">
                              <div class="col-12" :class="{'text-center': (topIndustries.length === 0)}">
                                <template v-if="topIndustries.length > 0">
                                  <div class="row bar_container mb-2" v-for="item in topIndustries">
                                    <div class="mt-2 ml-4 w-100">
                                      <span class="float-left">{{item.industry}}</span>
                                      <span class="float-right mr-4">{{item.totalCount}} jobs</span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span>Data not available</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 hd ace_sec" style="margin-bottom: 0px;" v-if="topJobTitles.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11 mb-2" style="margin-left: -25px;">
                        <div style="float: left; width: 350px;">
                          <h2 aria-label="Companies Hiring Alumni">Popular Alumni Job Titles</h2>
                        </div>                        
                      </div>
                      <div class="col-12 ace_sec bar_chart_container">
                        <div class="jobtitles bar_row" style="margin-left: 10px !important; margin-right: 32px !important;">
                          <div class="bar_content">
                            <div class="row">
                              <div class="col-12" :class="{'text-center': (topJobTitles.length === 0)}">
                                <template v-if="topJobTitles.length > 0">
                                  <div class="row bar_container mb-2" v-for="item in topJobTitles">
                                    <div class="mt-2 ml-4 w-100">
                                      <span class="float-left">{{item.jobTitle}}</span>
                                      <span class="float-right mr-4">{{item.totalCount}} jobs</span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span>Data not available</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </template>
              <template v-else>
                <b-jumbotron>
                  <h4 class="text-center ace_sec_txt">Spotlight Alumni data is not available.</h4>  
                </b-jumbotron>
              </template>
			  		</div>
		      </div>
        </div>
      </div>
		</div>
	</div>
</template>


<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import DoughnutChart from './DoughnutChart'
  import ProgramGuideMenu from './ProgramGuideMenu'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-guide-spotlight-alumni',
    props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'loadDataFromServer'],
    components: {
      DoughnutChart,
      ProgramGuideMenu
    },
    data: () => {
      return {
        topCareers: [],
        topCompanies: [],
        topIndustries: [],
        topJobTitles: [],
        programGuide: {},
        DEFAULT_TYPE: 'MAJOR',
        EXPLORE_RESULTS: 'exploreProgramGuideResults',
        growthPieOptions: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        }
      }
    },
    async created () {
      if (!this.alumniData || !this.alumniData.spotlightPerson) {
        await this.loadProgramAlumniData(this.programGuideCode)
      }
      this.populateTopCareers()
      this.populateTopCompanies()
      this.populateTopIndustries()
      this.populateTopJobTitles()
    },
    mounted () {
      this.loadSpotlightAlumniData()
    },
    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadProgramAlumniData',
        'loadTopAlumniCareers',
        'loadCareerByCode',
        'loadTopEmployersForAlumniCareer',
        'loadTopAlumniCompanies',
        'loadTopAlumniIndustries',
        'loadTopAlumniJobTitles'
      ]),
      async populateTopCareers () {
        this.topCareers = []
        let data = await this.loadTopAlumniCareers(this.programGuideCode)
        let careers = data.content
        for (let i = 0; i < careers.length; i++) {
          let ac = careers[i]
          let code = ac.careerPragyaSoc
          let career = await this.loadCareerByCode(code)
          if (career) {
            ac.medianIncome = career.medianEarning
            ac.minIncome = career.annualEarning10thPercentile
            ac.maxIncome = career.annualEarning90thPercentile
            ac.growth = career.growth
            ac.timeframe = career.timeframe
            ac.openings = career.openings
          }
          let employers = await this.loadTopEmployersForAlumniCareer({programCode: this.programGuideCode, careerSoc: ac.careerSoc})
          ac.employers = _.orderBy(employers, ['totalCount'], ['desc'])
          this.topCareers.push(ac)
        }
      },
      async populateTopCompanies () {
        let data = await this.loadTopAlumniCompanies(this.programGuideCode)
        this.topCompanies = data.content
      },
      async populateTopIndustries () {
        let data = await this.loadTopAlumniIndustries(this.programGuideCode)
        this.topIndustries = data.content
      },
      async populateTopJobTitles () {
        let data = await this.loadTopAlumniJobTitles(this.programGuideCode)
        this.topJobTitles = data.content
      },
      async loadSpotlightAlumniData () {
        let cipCode = this.cipCode
        let programGuideCode = this.programGuideCode
        let returnTo = this.returnTo || this.EXPLORE_RESULTS
        if (!cipCode || !programGuideCode) {
          return this.$router.push({ name: returnTo })
        }
        this.programGuide = await this.loadProgramGuide({
          cipCode: cipCode,
          programGuideCode: programGuideCode,
          type: this.programGuideType,
          loadDataFromServer: true
        })        
      },
      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.EXPLORE_RESULTS
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to all results'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      updateTitleHeight (index) {
        let titleContainerHeight = $('#title_' + index).height()
        if (titleContainerHeight > 30) {
          $('#biography_' + index).addClass('srt_desc')
        }
      },
      getClassOf (person) {
        if (person.educationInfoList && person.educationInfoList.length > 0) {
          return ' - Class of ' + person.educationInfoList[0].classOf
        }
        return ''
      },
      navigateToCareer (career) {
        let routerParams = {
          code: career.careerPragyaSoc,
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          returnTo: 'programGuideSpotlightAlumni',
          showBackToResultButton: true
        }
        return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'programGuideSpotlightAlumni'} })
      },
      addCommaInNumber (numValue) {
        if (numValue && numValue.length > 0) {
          let numericValue = Math.floor(numValue)
          return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return numValue
      },
      formatNumericVal (numValue) {
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },      
      callDrawNeedle (el, value) {
        if (!document || !document.getElementById(el)) return
        let canvas = document.getElementById(el).childNodes[1]
        if (canvas) {
          if (value && value < -10) {
            this.drawNeedle(canvas, 50, -170 * Math.PI / 180)
          } else if (value && value >= -10 && value < -5) {
            this.drawNeedle(canvas, 50, -150 * Math.PI / 180)
          } if (value && value >= -5 && value < 0) {
            this.drawNeedle(canvas, 50, -130 * Math.PI / 180)
          } else if (value && value >= 0 && value < 5) {
            if (value === '0.0') {
              this.drawNeedle(canvas, 50, -125 * Math.PI / 180)
            } else {
              this.drawNeedle(canvas, 50, -110 * Math.PI / 180)
            }
          } else if (value && value >= 5 && value < 10) {
            this.drawNeedle(canvas, 50, -90 * Math.PI / 180)
          } else if (value && value >= 10 && value < 15) {
            this.drawNeedle(canvas, 50, -70 * Math.PI / 180)
          } else if (value && value >= 15 && value < 20) {
            this.drawNeedle(canvas, 50, -50 * Math.PI / 180)
          } else if (value && value >= 20 && value < 25) {
            this.drawNeedle(canvas, 50, -30 * Math.PI / 180)
          } else if (value && value >= 25) {
            this.drawNeedle(canvas, 50, -10 * Math.PI / 180)
          }
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -5)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 5)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 7, 0, Math.PI * 2)
        ctx.fill()
      },
      getMoreLessLabel (index) {
        let label = ''
        let elemId = '#biography_' + index
        if ($(elemId).hasClass('description')) {
          label = 'more'
        } else {
          label = 'less'
        }
        return label
      },
      expandCollapseBio (index) {
        let elemId = '#biography_' + index
        $(elemId).toggleClass('description')
        let el = '#more-less-' + index
        if ($(elemId).hasClass('description')) {
          $(el).text('more')
        } else {
          $(el).text('less')
        }
      }
    },
    computed: {
      ...mapState({
        'alumniData': state => state.programguide.programAlumniData,
        'packages': state => state.institution.packages
      }),
      programGuideType () {
        let programGuideType = this.type
        if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
          programGuideType = this.DEFAULT_TYPE
        }
        return programGuideType
      },
      spotlightPersons () {
        if (this.alumniData && this.alumniData.spotlightPerson) {
          if (this.alumniData.spotlightPerson.length > 3) {
            return _.slice(this.alumniData.spotlightPerson, 0, 3)
          }
          return this.alumniData.spotlightPerson
        }
        return []
      },
      growthPieData () {
        let data = {
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        return data
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideSpotlightAlumni.vue